import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import EditModal from '../componentes/EditModal';
import DeleteConfirm from '../componentes/DeleteConfirm';
import { Plus } from 'lucide-react';

const MascotasPanel = () => {
  const [mascotas, setMascotas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  const fetchMascotas = async () => {
    try {
      setLoading(true);
      const res = await api.get('/mascotas');
      setMascotas(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMascotas(); }, []);

  const handleEdit = (mascota) => {
    setSelected({ ...mascota });
    setImageFile(null);
    setShowEdit(true);
  };

  const handleCreate = () => {
    setSelected(null);
    setImageFile(null);
    setShowEdit(true);
  };

  const handleDelete = (id) => {
    setSelected(mascotas.find(m => m.id === id));
    setShowDelete(true);
  };

  const handleSave = async (formData) => {
    // Campos de la mascota
    const payload = {
      nombre: formData.nombre,
      fecha_nacimiento: formData.fecha_nacimiento,
      sexo: formData.sexo,
      direccion: formData.direccion,
      descripcion: formData.descripcion,
      persona1: formData.persona1,
      persona1tel: formData.persona1tel,
      persona1ig: formData.persona1ig,
      persona2: formData.persona2,
      persona2tel: formData.persona2tel,
      persona2ig: formData.persona2ig,
      mensajeRescate: formData.mensajeRescate,
      id_usuario: formData.id_usuario, // admin puede asignar dueño
      codigo_id: formData.codigo_id,
    };

    let mascotaId = selected?.id;

    if (selected) {
      // Actualizar campos
      await api.put(`/mascotas/${selected.id}`, payload);
    } else {
      // Crear nueva mascota
      const res = await api.post('/mascotas', payload);
      mascotaId = res.data?.id || res.data?.mascota?.id;
      if (!mascotaId) throw new Error('No se obtuvo el ID de la mascota creada');
    }

    // Subir imagen si se seleccionó una nueva
    if (imageFile) {
      const imgForm = new FormData();
      imgForm.append('imagen', imageFile);
      // Si hay otros campos que queramos actualizar junto con la imagen, agregarlos
      Object.keys(payload).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null) {
          imgForm.append(key, payload[key]);
        }
      });
      await api.post(`/upload-mascota/${mascotaId}`, imgForm);
    }

    setShowEdit(false);
    fetchMascotas();
  };

  const confirmDelete = async () => {
    await api.delete(`/mascotas/${selected.id}`);
    setShowDelete(false);
    fetchMascotas();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'sexo', label: 'Sexo', render: (v) => v == 1 ? 'Hembra' : v == 0 ? 'Macho' : '-' },
    { key: 'id_usuario', label: 'Dueño ID' },
    { key: 'codigo_id', label: 'Código ID' },
    { key: 'fecha_nacimiento', label: 'Nacimiento' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Mascotas</h1>
        <button className="sp-btn sp-btn--primary" onClick={handleCreate}>
          <Plus size={18} /> Nueva
        </button>
      </div>

      <DataTable
        columns={columns}
        data={mascotas}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showEdit && (
        <EditModal
          title={selected ? 'Editar mascota' : 'Crear mascota'}
          fields={[
            { name: 'nombre', label: 'Nombre' },
            { name: 'sexo', label: 'Sexo (0=Macho, 1=Hembra)', type: 'number', min: 0, max: 1 },
            { name: 'fecha_nacimiento', label: 'Fecha de nacimiento', type: 'date' },
            { name: 'direccion', label: 'Dirección' },
            { name: 'descripcion', label: 'Descripción', type: 'textarea' },
            { name: 'persona1', label: 'Contacto 1 (nombre)' },
            { name: 'persona1tel', label: 'Tel. contacto 1' },
            { name: 'persona1ig', label: 'IG contacto 1' },
            { name: 'persona2', label: 'Contacto 2 (nombre)' },
            { name: 'persona2tel', label: 'Tel. contacto 2' },
            { name: 'persona2ig', label: 'IG contacto 2' },
            { name: 'mensajeRescate', label: 'Mensaje de rescate', type: 'textarea' },
            { name: 'id_usuario', label: 'ID del dueño', type: 'number' },
            { name: 'codigo_id', label: 'ID del código QR', type: 'number' },
            { name: 'imagen', label: 'Foto', type: 'file', accept: 'image/*', onChange: (e) => setImageFile(e.target.files[0]) },
          ]}
          initialValues={selected || {}}
          onSave={handleSave}
          onCancel={() => setShowEdit(false)}
        />
      )}

      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar a ${selected.nombre}?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default MascotasPanel;